module.exports = __webpack_public_path__ + "8ed2bdc8c4f870850c78e19ec268538e.svg";